import _jsx from "@babel/runtime/helpers/jsx";
var _g;
import React from 'react';
function ConfirmationIcon(_ref) {
  let {
    width = 20
  } = _ref;
  return /*#__PURE__*/_jsx("svg", {
    width: width,
    strokeWidth: "5.5",
    strokeLinecap: "round",
    stroke: "currentColor",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, _g || (_g = /*#__PURE__*/_jsx("g", {
    fill: "none",
    strokeWidth: "6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, void 0, /*#__PURE__*/_jsx("path", {
    d: "M30.9,5.9C16.8,5.9,5.4,17.4,5.4,31.5s11.4,25.6,25.5,25.6s25.5-11.5,25.5-25.6S45,5.9,30.9,5.9z"
  }), /*#__PURE__*/_jsx("polyline", {
    points: "16.6,26.1 30.5,40 59.8,10.7 "
  }))));
}
export default ConfirmationIcon;